'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './service-requests-edit.routes';

export class ServiceRequestsEditComponent {

  constructor(IntegrationService, Auth, dialogs, $state, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Auth = Auth;
    this.dialogs = dialogs;
    this.$state = $state;
    this.integrationAvailable = true;
    this.IntegrationService = IntegrationService;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Service Request");

    this.configMS = Config.getPlatformConfig().getManagementSuiteIntegratonSettings();

    if (!this.configMS) {
      this.integrationAvailable = false;
    }

    let user = Auth.getCurrentUserSync();
    let fullName = user.firstName;
    if (user.middleName)
      fullName += " " + user.middleName;
    fullName += " " + user.lastName;

    this.model = {
      requester: {
        email: user.email,
        fullName: fullName,
        firstName: user.firstName,
        middleName: user.middleName,
        lastName: user.lastName,
        communityCode: this.configMS.clientCode
      }
    };

    IntegrationService.test(result => {
      if (!result || !result.status || !result.status == 'successful') {
        this.integrationAvailable = false;
      } else {

        IntegrationService.queryServiceRequestCodes(data => {
          this.codes = data;
          this.codesEnum = data.map(code => code.code);
        });

      }
    })
  }

  codeChanged () {
    let oCode = this.codes.find(code => code.code == this.model.code);

    if (!oCode)
      return;

    this.model.sequence = oCode.sequence;
    this.model.name = oCode.name;
    this.model.description = oCode.description;
    this.model.instructions = oCode.instructions;
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var dlg = this.dialogs.notify("Success", "The service request ticket has been created successfully");
        dlg.result.then(() => {
          that.$state.go("service-requests-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.IntegrationService.saveServiceRequest(this.model, onSuccess, onError);
    }
  }
}

export default angular.module('conduuApp.serviceRequests.edit', [uiRouter])
  .config(routes)
  .component('serviceRequestsEdit', {
    template: require('./service-requests-edit.html'),
    controller: ServiceRequestsEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/service-requests/edit/service-requests-edit.component.js